import { useState } from "react";
import { Box, Paper, Typography } from "@mui/material";
import TableModeSwitch from "../../components/TableModeSwitch";
import ResizablePanel from "../../components/ResizablePanel";
import faqContent from "./faqContent.txt?raw";

const faqBody = faqContent
  .replace(/^#\s*ReliablyME Chatbot\s*\n/i, "")
  .replace(/^#\s*Frequently Asked Questions\s*\n/i, "")
  .trim();

/** Static FAQ copy: escape HTML, then **bold** and bare https URLs. */
function formatFaqHtml(text: string): string {
  let html = text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
  html = html.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
  html = html.replace(
    /(https?:\/\/[^\s<]+)/g,
    '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>',
  );
  return html;
}

const FaqPage = () => {
  const [viewMode, setViewMode] = useState<"regular" | "table">("regular");
  const tableMode = viewMode === "table";

  return (
    <Box
      sx={{
        maxWidth: tableMode ? 1400 : 960,
        mx: "auto",
        px: { xs: 1.5, sm: 2, md: 3 },
        py: tableMode ? 2 : 3,
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
          mb: 2,
          flexWrap: "wrap",
        }}
      >
        <Typography variant="h4" component="h1" sx={{ fontWeight: 600 }}>
          Frequently Asked Questions
        </Typography>
        <TableModeSwitch
          checked={tableMode}
          onChange={(next) => setViewMode(next ? "table" : "regular")}
        />
      </Box>
      <ResizablePanel storageKey="faq-main" defaultHeight={tableMode ? 640 : 720} minHeight={280}>
        <Paper
          elevation={0}
          sx={{
            p: tableMode ? { xs: 1.5, sm: 2 } : { xs: 2, sm: 3 },
            bgcolor: "background.paper",
            height: "100%",
          }}
        >
          <Box
            component="div"
            sx={{
              whiteSpace: "pre-wrap",
              fontFamily: '"Source Sans Pro", "Roboto", "Helvetica", "Arial", sans-serif',
              fontSize: tableMode ? "0.9rem" : "0.95rem",
              lineHeight: 1.65,
              color: "text.primary",
              columnCount: tableMode ? { xs: 1, sm: 2 } : 1,
              columnGap: tableMode ? 3 : 0,
              "& a": { color: "primary.main", wordBreak: "break-all" },
              "& strong": { fontWeight: 600 },
            }}
            dangerouslySetInnerHTML={{ __html: formatFaqHtml(faqBody) }}
          />
        </Paper>
      </ResizablePanel>
    </Box>
  );
};

export default FaqPage;
